import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Thumbnails from '../../../components/Editor/Thumbnails';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			thumbnails,
			isThumbnailsDisplayed,
			slider: { page, totalPages },
			activeItem,
			pageSelection: { isActive, pages },
		},
	} = state;

	return {
		items: thumbnails,
		isDisplayed: isThumbnailsDisplayed,
		currentPage: page,
		totalPages,
		isSomeEditableItemActive: !!activeItem.id,
		isPageSelectionActive: isActive,
		selectedPages: pages,
	};
};

export default connect(mapStateToProps)(Thumbnails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Thumbnails/index.tsx